import React from 'react'
import { Setters } from 'src/features/atoms/glove/japan/Components'
import { OrderPageTemplate } from 'src/Components/Domain/OrderPageTemplate'
import { pitcherReducer } from 'src/features/atoms/glove/japan/slice/pitcher'
import { useLocale } from 'src/locales/useLocale'
import { BaseModelSelector } from 'src/Components/Domain/BaseModelSelector'
import { useRouter } from 'next/router'
import { atomsBaseModel } from 'src/features/atoms/glove/japan/constants/baseModel'
import { SET_FIGURE_PANEL_NUMBER } from 'src/features/atoms/glove/japan/constants/actionType'

const AtomsPitcher: React.FC = () => {
  const { t } = useLocale()
  const router = useRouter()
  const models = atomsBaseModel(t, router)
  const [state, dispatch] = React.useReducer(pitcherReducer, t.INITIAL_STATE_PITCHER)

  const { figurePanelNum } = state
  const handleFigurePanelNum = (_, newValue: 0 | 1) => dispatch({ ...state, type: SET_FIGURE_PANEL_NUMBER, figurePanelNum: newValue })
  return (
    <OrderPageTemplate
      breadcrumbTrail={`${t.HARD} / ATOMS / ${t.PITCHER}`}
      brand={'atoms'}
      {...{ figurePanelNum, state, dispatch, handleFigurePanelNum }}
    >
      <BaseModelSelector {...{ state, models, dispatch }} />
      <Setters {...{ state, figurePanelNum, dispatch }} />
    </OrderPageTemplate>
  )
}

export default AtomsPitcher
